import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Harsh Talwar",
      position: "CEO of Cash For Phone",
      image: "/assets/images/Harsh Talwar.png",
      content: "I came to know about Akir Advisory from my friend. From the inception of my firm, their team have been good and reliable. I have recommended them to many entrepreneurs already.",
      rating: 5
    },
    {
      id: 2,
      name: "Gaurav Goel",
      position: "Designated Partner of Superkart International LLP",
      image: "/assets/images/Gaurav goel.jpeg",
      content: "Akir Advisory has supported us in the legal compliance and due diligence for the merger of our Family Business to consolidate in a LLP. We are grateful to receive constant support and guidance from Akir advisory.",
      rating: 5
    },
    {
      id: 3,
      name: "Praveen Choudhary",
      position: "Managing Director at Karam Cargo Logistic Private Limited",
      image: "/assets/images/Praveen ji.jpg",
      content: "Thank you very much for supporting our business activities - the Business Solution & suggestions your team providing us will continue to guide our team to upgrade our system. I am grateful to Akir Advisory for assisting with their valuable business advisory services.",
      rating: 5
    },
    {
      id: 4,
      name: "Kunal Arora",
      position: "Owner of M/S K Nine Apparels",
      image: "/assets/images/Kunal Arora.jpg",
      content: "For somebody who is not aware of the procedures for GST registration and compliances applicable, this would be the best place to checkout. They assist me with every single detail and replied to all the queries. Thank you for providing service in a very professional manner.",
      rating: 5
    },
    {
      id: 5,
      name: "Jeevesh Kumar",
      position: "CEO of Greenscape Eco Management Private Limited",
      image: "/assets/images/Jeevesh Kumar.png",
      content: "I highly recommend Akir Advisory for anybody who is planning to set up a company in India. The professionalism they displayed made me more attracted to them. let me use this opportunity to commend CA Sonu Jha, Overall good and satisfied. Keep it up.",
      rating: 5
    },
    {
      id: 6,
      name: "Jitender Bhatia",
      position: "CEO & Director of Davabikri",
      image: "/assets/images/Mr Jitender Bhatia Director.jpeg",
      content: "Akir Advisory revolutionized our company's operations through their expert digitalization and process automation services. Their professionalism, deep understanding of our needs, and cutting-edge solutions have boosted productivity and efficiency. We highly recommend Akir Advisory for transformative business solutions.",
      rating: 5
    },
    {
      id: 7,
      name: "Kripal Singh",
      position: "Operation Head and Director of Vista Lightscape Pvt. Ltd.",
      image: "/assets/images/Kirpal Singh.jpeg",
      content: "Thank you very much for supporting our business activities - the Business Solution & suggestions your team providing us will continue to guide our team to upgrade our system. I am grateful to Akir Advisory for assisting with their valuable business advisory services.",
      rating: 5
    },
    {
      id: 8,
      name: "Sachin Verma",
      position: "Founder and Operation Head at AARIYA REGULATORY SERVICES PRIVATE LIMITED",
      image: "/assets/images/Sachin Verma.png",
      content: "Aariya Regulatory is a consistent customer and appreciates the relationship we have with this team. They are fast, reliable and attentive. We have been using them for a couple of years now and we will continue to have them as part of our business.",
      rating: 5
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className="text-yellow-400">
        {index < rating ? '★' : '☆'}
      </span>
    ));
  };

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center" style={{ backgroundImage: `url('https://placehold.co/1D4ED8/ffffff?')` }}></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Client Testimonials
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Discover what our clients have to say about their experience with Akir Advisory. Real stories from real businesses we've helped succeed.
            </p>
            <div className="mt-8">
              <a 
                href="#testimonials-grid" 
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105"
              >
                <span className="mr-2">💬</span> Read Client Stories
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Grid Section */}
      <section id="testimonials-grid" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Success Stories
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Our Clients Say About Us
            </p>
            <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
              Don't just take our word for it. Here's what entrepreneurs and business owners have to say about their experience with Akir Advisory.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div 
                key={testimonial.id} 
                className="bg-white p-6 rounded-xl shadow-lg border-l-4 border-blue-600 hover:shadow-xl transition duration-300"
              >
                <div className="flex items-center mb-4">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name} 
                    className="w-12 h-12 rounded-full object-cover mr-4"
                    onError={(e) => {
                      e.target.src = `https://placehold.co/100x100/3B82F6/ffffff?text=${testimonial.name.charAt(0)}`;
                    }}
                  />
                  <div>
                    <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                    <p className="text-sm text-gray-600">{testimonial.position}</p>
                  </div>
                </div>
                <div className="flex text-yellow-400 mb-3">
                  {renderStars(testimonial.rating)}
                </div>
                <p className="text-gray-700 italic">
                  "{testimonial.content}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="py-16 bg-blue-600/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div className="flex flex-col items-center p-4">
              <p className="text-4xl font-extrabold text-white">910+</p>
              <p className="mt-2 text-sm font-medium text-blue-100 uppercase tracking-wider">
                Happy Clients
              </p>
            </div>
            <div className="flex flex-col items-center p-4">
              <p className="text-4xl font-extrabold text-white">98%</p>
              <p className="mt-2 text-sm font-medium text-blue-100 uppercase tracking-wider">
                Satisfaction Rate
              </p>
            </div>
            <div className="flex flex-col items-center p-4">
              <p className="text-4xl font-extrabold text-white">4.9/5</p>
              <p className="mt-2 text-sm font-medium text-blue-100 uppercase tracking-wider">
                Average Rating
              </p>
            </div>
            <div className="flex flex-col items-center p-4">
              <p className="text-4xl font-extrabold text-white">99%</p>
              <p className="mt-2 text-sm font-medium text-blue-100 uppercase tracking-wider">
                On-Time Delivery
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold text-gray-900">
            Ready to Become Our Next Success Story?
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Join hundreds of satisfied clients who have transformed their business with Akir Advisory's expert services.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <a
              href="/#contact"
              className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-white bg-blue-600 hover:bg-blue-700 transition duration-150 ease-in-out transform hover:scale-105"
            >
              <span className="mr-2">📞</span> Get Started Today
            </a>
            <a
              href="/#services"
              className="inline-flex items-center justify-center px-8 py-3 border border-blue-600 text-base font-medium rounded-full text-blue-600 bg-white hover:bg-blue-50 transition duration-150 ease-in-out transform hover:scale-105"
            >
              <span className="mr-2">💼</span> Explore Services
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Testimonials;